<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      visible
      direction="rtl"
      :size="1200"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div>
        <div class="p-2">
          <el-form
            ref="form"
            :model="formData"
            :rules="rules"
            size="small"
            v-if="type === 'reject'"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item
                  :label="$l('label_reject_reason') || '驳回原因'"
                  prop="rejectReason"
                >
                  <el-input
                    v-model="formData.rejectReason"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    clearable
                    type="textarea"
                    :maxlength="200"
                    show-word-limit
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="text-right">
            <el-button size="small" @click="handleClose(() => close())">
              {{ $l('INDEX.btn_close') || '关闭' }}
            </el-button>
            <el-button
              type="success"
              size="small"
              @click="approved()"
              v-if="type === 'approved'"
            >
              {{ $l('btn_passed') || '通过' }}
            </el-button>
            <el-button
              type="danger"
              size="small"
              @click="reject()"
              v-if="type === 'reject'"
            >
              {{ $l('btn_reject') || '驳回' }}
            </el-button>
          </div>
        </div>

        <AwsSku disabled :amzSkuCode="amzSkuCode" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
import AwsSku from '@/views/ecom/base/awsGoods/components/aws-sku'
export default {
  mixins: [EditLoading],
  components: { AwsSku },
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' },
    amzSkuCode: { type: String, default: '' },
    applicationStatus: { type: String, default: '' },
  },
  data() {
    return {
      titleMap: {
        'approved-O': this.$l('dialog_title_approved-O') || '通过可下单',
        'reject-O': this.$l('dialog_title_reject-O') || '驳回可下单',
        'approved-A': this.$l('dialog_title_approved-A') || '通过信息提交',
        'reject-A': this.$l('dialog_title_reject-A') || '驳回信息提交',
      },
      formData: {},
      rules: {
        rejectReason: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    title() {
      return (
        this.titleMap[`${this.type}-${this.applicationStatus}`] ||
        this.$l('dialog_title_detail') ||
        'Amazon产品详情'
      )
    },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    handleClose(done) {
      return done()
    },
    approved() {
      this.applicationStatus === 'O'
        ? this.purchasableApproved()
        : this.informationApproved()
    },
    async reject() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      this.applicationStatus === 'O'
        ? this.purchasableReject()
        : this.informationReject()
    },
    async purchasableApproved() {
      const confirm = await this.$confirm(
        this.$l('tips_pass_place_order') || '是否要通过该SKU可下单申请？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return false
      if (this.loadingOpen()) return
      const listAmzSkuCode = [this.amzSkuCode]
      const res = await this.$api
        .ecomAmzSkuPurchasableApprovedApi({ listAmzSkuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_pass_failed') || '通过失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_pass_success') || '通过成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    async informationApproved() {
      const confirm = await this.$confirm(
        '是否要通过该SKU信息确认申请？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return false
      if (this.loadingOpen()) return
      const listAmzSkuCode = [this.amzSkuCode]
      const res = await this.$api
        .ecomAmzSkuInformationApprovedApi({ listAmzSkuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_pass_failed') || '通过失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_pass_success') || '通过成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    async purchasableReject() {
      const confirm = await this.$confirm(
        '是否要驳回该SKU可下单申请？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return false
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzSkuPurchasableRejectApi({
          amzSkuCode: this.amzSkuCode,
          ...this.formData,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_reject_failed') || '驳回失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_reject_success') || '驳回成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    async informationReject() {
      const confirm = await this.$confirm(
        '是否要驳回该SKU信息确认申请？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return false
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzSkuInformationRejectApi({
          listAmzSkuCode: [this.amzSkuCode],
          ...this.formData,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_reject_failed') || '驳回失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_reject_success') || '驳回成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 10px 12px;
}

::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}
</style>
